import { useAttachments } from '@renderer/chat/store/attachments'
import { useSelectedWindows } from '@renderer/chat/store/atoms'
import { InputAttachments } from '@renderer/chat/components/chat/input/context/input-attachments'
import { WindowContext } from '@renderer/chat/components/chat/input/context/window-context'

/**
 * What's been added from the plus, as the composer's removable chips. Hides the screen pill the composer
 * suggests on its own, so only what the user picked shows.
 */
export function SidebarSearchAttachments() {
  const attachments = useAttachments()
  const selectedWindows = useSelectedWindows()
  if (attachments.length === 0 && selectedWindows.length === 0) {
    return null
  }
  return (
    <div className="flex flex-wrap items-center gap-0.5 pt-1.5 [&_[data-window-context]]:hidden">
      <WindowContext />
      <InputAttachments />
    </div>
  )
}
